export default "__VITE_ASSET__BQWekdtY__"